import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { Modal } from '@/components';
import { useBackgroundTasksStore } from '@/store/background-tasks/background-tasks.store.ts';
import type { ItinerarySuggestionResponse } from '@/types/itineraryTypes.ts';
import { Button, ButtonOutlined, ButtonOutlinedSmall } from '@/components/Button';

import styles from './TaskNotifier.module.scss';

const TaskNotifier = () => {
  const tasks = useBackgroundTasksStore((s) => s.tasks);
  const acknowledge = useBackgroundTasksStore((s) => s.acknowledge);
  const navigate = useNavigate();

  const completed = useMemo(
    () => Object.values(tasks).find((t) => t.status === 'success' || t.status === 'error'),
    [tasks],
  );

  if (!completed) return null;

  const handleOpen = () => {
    if (completed.navigateTo) {
      navigate(completed.navigateTo, {
        state:
          completed.type === 'itinerary'
            ? { itinerarySuggestion: completed.result as ItinerarySuggestionResponse }
            : undefined,
      });
    }
    acknowledge(completed.id);
  };
  const handleClose = () => acknowledge(completed.id);

  return (
    <Modal
      open
      onClose={handleClose}
      title={
        completed.status === 'success'
          ? `${completed.label} ready`
          : `Couldn’t Finish ${completed.label}`
      }
    >
      <div className={styles.body}>
        {completed.status === 'success' ? (
          <>
            <p className={styles.text}>
              Your {completed.label.toLowerCase()} has finished. Open the results?
            </p>
            <div className={styles.actions}>
              <ButtonOutlined onClick={handleClose}>Dismiss</ButtonOutlined>
              <Button onClick={handleOpen}>Open</Button>
            </div>
          </>
        ) : (
          <>
            <p className={styles.text}>
              Something went wrong during {completed.label.toLowerCase()}. Please try again.
            </p>
            <div className={styles.actions}>
              <ButtonOutlinedSmall onClick={handleClose}>Close</ButtonOutlinedSmall>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default TaskNotifier;
